<template>
  <div class="filter">
    <div class="filter_form">
      <div class="left_info">
        <div class="row">
          <h1>{{ courseInfo.category_name }}</h1>
          <h1>{{ courseInfo.name }}</h1>
        </div>
        <ul>
          <li>
            <span class="grey">Проходят всего</span>
            <span class="black">{{ courseInfo.total }}</span>
          </li>
          <li>
            <span class="grey">Прошли</span>
            <span class="black">{{ courseInfo.passed }}</span>
          </li>
          <li>
            <span class="grey">Не прошли курс</span>
            <span class="black">{{ courseInfo.not_passed }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="filter_actions">
      <b-field type="is-info" class="user_select link_input with_borders">
        <customSelect
          @input="onFilterChange($event, 'stage_id')"
          :value="search.stage_id"
          placeholder="Урок/Тест"
          :keys="['id', 'name']"
          :multiple="false"
          :options="stagesList.filter((el) => el.type !== 1)"
        />
      </b-field>
      <b-field class="input_search" type="is-info">
        <b-input v-model="search.name" @input="onFilterChange($event, 'name')"
         placeholder="Поиск по ФИО"></b-input>
      </b-field>
      <button class="search-button" @click="onSearch">Поиск</button>
    </div>
  </div>
</template>

<script>
import customSelect from '@/components/ui/customSelect'

export default {
  components: {
    customSelect
  },
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    },
    search: {
      default: () => {},
      type: Object
    },
    stagesList: {
      default: () => [],
      type: Array
    }
  },
  methods: {
    onFilterChange(val, filterName) {
      this.search[filterName] = (val === 0 || val === '') ? null : val;
    },
    onSearch() {
      this.$emit('change')
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    branchesList() {
      return this.$store.state.right.rightBranchesList
    },
    usersList() {
      let data = this.$store.state.courses.courseStatistic
      data.forEach((usr) => {
        usr['fio'] = usr.surname + ' ' + usr.name + ' ' + usr.patronymic
      })
      return data
    }
  }
}
</script>
